// src/utils/contatoriUtils.js
// Unico posto dove vive la generazione di numeri progressivi (DDT, Sopralluoghi, Rapportini,
// Richieste Commerciali, Segnalazioni Cliente, Rientro Materiali, Elaborazione Offerte,
// Numero Cliente, Fatturazione, NF, ODA...) — una vera transazione Firestore, non una lettura
// e una scrittura separate: due richieste nello stesso istante non possono mai ricevere lo
// stesso numero. Prima di questa unificazione, ogni funzionalità aveva la propria copia dello
// stesso codice (quasi tutte senza transazione) — un numero duplicato in una di queste, dopo
// mesi di lavoro, è quello che ha fatto scoprire il problema.
import { doc, runTransaction } from "firebase/firestore";
import { db } from "../firebase";

// chiave: es. `${orgId}_ddt_${anno}` — univoca per tipo di documento, organizzazione e (se
// pertinente) anno. datiExtra: campi aggiuntivi da salvare nel documento contatore (orgId,
// anno...), utili solo per poterlo ispezionare a mano su Firestore in caso di dubbi.
export async function prossimoProgressivo(chiaveContatore, datiExtra = {}, basePartenza = 0) {
  const contatoreRef = doc(db, "contatori", chiaveContatore);
  return runTransaction(db, async (transaction) => {
    const snap = await transaction.get(contatoreRef);
    const progressivo = (snap.exists() ? (snap.data().ultimo || basePartenza) : basePartenza) + 1;
    transaction.set(contatoreRef, { ultimo: progressivo, ...datiExtra }, { merge: true });
    return progressivo;
  });
}

// Variante per contatori che, prima di questa correzione, non avevano un documento contatore
// dedicato (es. Comunicazioni: il numero veniva ricavato scorrendo tutti i documenti esistenti
// e prendendo il più alto trovato). Se il contatore non esiste ancora, lo inizializza al volo
// usando il valore massimo già in uso (calcolato una sola volta, fuori dalla transazione, per
// non rompere la numerazione già esistente) — poi si comporta come una transazione normale.
// Il calcolo del massimo esistente va passato come funzione, eseguita solo se necessario.
export async function prossimoProgressivoConSeed(chiaveContatore, calcolaMassimoEsistente, datiExtra = {}) {
  const contatoreRef = doc(db, "contatori", chiaveContatore);
  return runTransaction(db, async (transaction) => {
    const snap = await transaction.get(contatoreRef);
    let base = 0;
    if (snap.exists()) {
      base = snap.data().ultimo || 0;
    } else {
      base = await calcolaMassimoEsistente();
    }
    const progressivo = base + 1;
    transaction.set(contatoreRef, { ultimo: progressivo, ...datiExtra }, { merge: true });
    return progressivo;
  });
}

// Riserva in un colpo solo un intero blocco di "quantita" numeri consecutivi (es. importazione
// massiva di più clienti in una volta) — una sola transazione invece di una per riga, ma
// comunque al sicuro da un'altra importazione o creazione partita nello stesso istante.
// Restituisce il numero di partenza: il chiamante assegna localmente inizio+1, inizio+2, ecc.
export async function prossimoBloccoProgressivo(chiaveContatore, quantita, datiExtra = {}, basePartenza = 0) {
  const contatoreRef = doc(db, "contatori", chiaveContatore);
  return runTransaction(db, async (transaction) => {
    const snap = await transaction.get(contatoreRef);
    const inizio = snap.exists() ? (snap.data().ultimo || basePartenza) : basePartenza;
    transaction.set(contatoreRef, { ultimo: inizio + quantita, ...datiExtra }, { merge: true });
    return inizio;
  });
}
